import styled from 'shared/utils/styled';

import Input, { inputClasses } from '@mui/material/Input';

type InputAccessories = {
  variant: 'standard' | 'underline';
};

export const StyledInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<InputAccessories>(({ variant }) => ({
  [`&.${inputClasses.root}`]: {
    width: '100%',
    fontFamily: 'NeoSansStd',
    fontSize: 14,
    border: '1px solid rgba(34, 64, 96, 0.2)',
    color: '#224060',
    ...(variant === 'underline' && {
      border: 0,
      borderBottom: '1px solid rgba(34, 64, 96, 0.2)',
    }),
  },
  [`& .${inputClasses.input}`]: {
    padding: '7px 9px',
    '::placeholder': {
      color: 'rgba(34, 64, 96, 0.6)',
    },
  },
}));
